import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import pt from "./locales/pt.json";
import it from "./locales/it.json";
import ko from "./locales/ko.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import ru from "./locales/ru.json";
import nl from "./locales/nl.json";
import cs from "./locales/cs.json";
import id from "./locales/id.json";

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'customDetector',
  lookup() {
    // Check localStorage first
    const stored = localStorage.getItem('i18nextLng');
    if (stored) return stored;
    
    // Then check browser language
    const browserLang = navigator.language || (navigator as any).userLanguage;
    console.log('Browser language detected:', browserLang);
    
    // Extract language code (e.g., 'en-US' -> 'en')
    const langCode = browserLang.split('-')[0];
    
    // Check if we support this language
    const supportedLanguages = ['en', 'es', 'fr', 'de', 'zh', 'ja', 'pt', 'it', 'ko', 'ar', 'hi', 'ru', 'nl', 'cs', 'id'];
    if (supportedLanguages.includes(langCode)) {
      console.log('Using detected language:', langCode);
      return langCode;
    }
    
    console.log('Language not supported, falling back to English');
    return 'en';
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  }
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      zh: { translation: zh },
      ja: { translation: ja },
      pt: { translation: pt },
      it: { translation: it },
      ko: { translation: ko },
      ar: { translation: ar },
      hi: { translation: hi },
      ru: { translation: ru },
      nl: { translation: nl },
      cs: { translation: cs },
      id: { translation: id },
    },
    fallbackLng: "en",
    debug: true, // Enable debug mode to see what's happening
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['customDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // Disable suspense to avoid waiting for translations
    }
  });

// Log current language on initialization
i18n.on('initialized', (options) => {
  console.log('i18n initialized with language:', i18n.language);
});

i18n.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
});

export default i18n;
